<template>
  <div class="form__container">
    <div class="description">
      <span class="description__title">
        {{ $t('login.mfaDescPhrase1') }}
      </span>
      <span class="description__text">
        {{ $t('login.mfaDescPhrase2') }}
      </span>
    </div>
    <div
      class="input"
    >
      <div
        v-for="n in 6"
        :key="n - 1"
        class="input__section"
      >
        <input
          ref="mfaInput"
          v-model="otpInput[n - 1]"
          type="text"
          maxlength="1"
          @input="input(n - 1, ...arguments)"
          @paste="pasteOtpFromClipboard"
        >
      </div>
    </div>
    <div
      class="errormessage"
      :style="{ opacity: isInvalidInput ? 1 : 0 }"
    >
      {{ errorMessage }}
    </div>
    <div class="description">
      <span class="description__title">
        {{ $t('login.otpNotArrived') }}
      </span>
      <a
        class="description__link"
        @click="returnToLoginPage"
      >
        {{ $t('login.missingOtpReturnToLogin') }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    authSessionId: { type: String, default: null },
  },
  data: () => ({
    errorMessage: null,
    otpInput: [],
    isInvalidInput: false,
    failedAuthAttempts: 0,
  }),
  computed: {
  },
  methods: {
    ...mapActions(['authenticateWithOtp']),
    async input(idx) {
      if (!['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].includes(this.otpInput[idx])) this.otpInput[idx] = null;
      else if (idx < 5) this.$refs.mfaInput[idx + 1].focus();
      else if (idx === 5) await this.submitForm();
    },
    async submitForm() {
      try {
        await this.authenticateWithOtp({ otp: this.otpInput.join(''), sessionId: this.authSessionId });
        this.isInvalidInput = false;
        const returnUrl = this.$route.query.ReturnUrl || '/';
        await this.$router.push(returnUrl);
      } catch (e) {
        this.isInvalidInput = true;
        this.failedAuthAttempts += 1;
        switch (e.message) {
        case 'INVALID_OTP':
          this.errorMessage = this.$t('login.otpInvalidOrExpired');
          break;
        default:
          this.errorMessage = this.$t('login.otpDefaultIssuePhrase');
          break;
        }
        if (this.failedAuthAttempts >= 5) {
          const delay = 1000;
          setTimeout(async () => { await this.returnToLoginPage(); }, delay);
        }
      }
    },
    async returnToLoginPage() {
      await this.$router.push('/Login');
      this.$router.go();
    },
    async pasteOtpFromClipboard(e) {
      e.preventDefault();
      const pasteString = e?.clipboardData?.getData('text/plain') || await navigator?.clipboard?.readText();
      if (pasteString) {
        for (let i = 0; i < 6; i += 1) {
          this.otpInput[i] = pasteString[i];
          this.input(i);
        }
      }
    },
  },
};
</script>

<style scoped>
  .dark-theme .webeo-container {
    border: 1px solid var(--webeo-white);
    background-color: var(--webeo-background-2);
  }

  .input {
    display: flex;
    justify-content: center;
    padding: 0 75px;
  }
  .input__section {
    flex-direction: row;
    width: 50px;
    height: 70px;
    margin: 0 10px;
  }

  .input__section > input {
    color: #263238;
    width: 100%;
    max-width: 100%;
    padding: 10px 10px 10px 5px;
    box-sizing: border-box;
    margin-bottom: 20px;
    border: 1px solid #dcdcdc;
    border-radius: 4px;
    transition: border 0.2s ease-in-out;
    font-size: 30px;
    text-align: center;
  }

  .dark-theme .input__section input {
    background-color: var(--webeo-background-2) !important;
    color: var(--webeo-white) !important;
  }

  input:hover {
    border: 1px solid #bdbdbd;
  }

  input:focus {
    border: 1px solid var(--webeo-secondary);
    outline: none;
  }

  .errormessage {
    font-size: 11px;
    color: red;
    opacity: 0;
    transition: 0.3s opacity;
    height: 20px;
    padding: 0 75px;
    margin: 0 0 25px;
  }

  .description__title {
    font-weight: bold;
    font-size: 15px;
    padding-bottom: 10px;
  }

  .description {
    display: flex;
    flex-direction: column;
    padding: 0 75px;
    margin: 0 0 25px;
  }

  .description__text,
  .description__link {
    justify-content: center;
    font-size: 14px;
  }

  .description__link {
    text-decoration: underline;
    color: var(--webeo-cyan);
  }

  .description__link:hover {
    cursor: pointer;
    text-decoration: none;
  }
</style>
